if (!customElements.get("product-recommendations")) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }

    handleIntersection(entries, observer) {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.querySelector("[data-slider]")?.initSlider();
          }

          recommendations.querySelectorAll("script").forEach((item) => {
            const script = document.createElement("script");
            script.innerText = item.innerText;
            this.appendChild(script);
          });

          var api = new Yotpo.API(yotpo);
          api.refreshWidgets();

          const mutationTargets = document.querySelectorAll(
            ".js-mutation-target"
          );

          const mutationObserver = new MutationObserver((mutationList) => {
            for (const mutation of mutationList) {
              const target = mutation.target;
              if (!target) return;

              if (mutation.type === "childList") {
                const text = target.querySelector("a[tabindex]");
                if (!text) return;
                text.innerText = text.innerText.split(" ")[0];
              }
            }
          });

          mutationTargets.forEach((target) => {
            mutationObserver.observe(target, {
              childList: true,
              subtree: true,
            });
          });
        })
        .catch((e) => {
          console.error(e);
        });
    }

    connectedCallback() {
      new IntersectionObserver(this.handleIntersection.bind(this), {
        rootMargin: "0px 0px 200px 0px",
      }).observe(this);
    }
  }

  customElements.define("product-recommendations", ProductRecommendations);
}
